<template>
    <div class='order_data'>
        <div class="order_data_img">
            <img src="/static/images/orderData.png" alt="">
        </div>
        <div class="order_data_desc">
            <div class="order_title">订单数据</div>
            <div class="order_desc">订单数据一站式搜索，跨系统查看车主名下的购车订单、服务订单的进度</div>
        </div>
        <div class="order_btn" @click="order_func">对功能的心愿戳这里</div>
    </div>
</template>
<script>
export default {
    data(){
        return{

        }
    },
    mounted(){
    },
    methods:{
        order_func(){
            this.$router.push({name:'feedback',params:{
                from:'orderData'
            }});
        }
    }
}
</script>
<style lang="scss" scoped>
.order_data{
    display: flex;
    flex-direction: column;
    height: 100%;
    padding-bottom: j(30);
    box-sizing: border-box;
    align-items: center;
    .order_data_img {
        width: 100%;
        img {
            width: 100%;
            display: block;
        }
    }
    .order_data_desc {
        margin-top: j(120);
        width: j(650);
        flex: 1;
        background: #fff;
        color: #363C54;
        .order_title {
            font-size: j(50);
            font-weight: bold;
            margin-bottom: j(30);
        }
        .order_desc {
            font-size: j(30);
        }
    }
    .order_btn {
        width: j(650);
        height: j(90);
        line-height: j(90);
        text-align: center;
        font-size: j(32);
        color: #fff;
        background :#00BCBC;
        border-radius: j(50);
    }
}
</style>





// WEBPACK FOOTER //
// src/views/orderData.vue